package com.eladfinish.bible.contest.common.usecases

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannedRange
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class MakeOtiotPerekBoldUseCase {

    operator fun invoke(
        charSequence: CharSequence,
    ): ImmutableList<SpannedRange> {
        val spannedRangeList = mutableListOf<SpannedRange>()
        StringConstants.Regex.PEREK.toRegex().findAll(charSequence).forEach {
            spannedRangeList.add(
                SpannedRange(
                    spanType = SpanType.Bold,
                    textRange = TextRange(start = it.start, end = it.end),
                )
            )
        }
        return spannedRangeList.toImmutableList()
    }

}
